import "core-js/modules/web.dom-collections.iterator.js";
import { jsx as _jsx } from "react/jsx-runtime";
import requestIdleCallback from 'framework/utils/requestIdleCallback';
import { useEffect, useState } from 'react';
function PauseAnimations() {
    const [pauseAllAnimations, setPauseAllAnimations] = useState(true);
    useEffect(()=>{
        const handleLoad = ()=>{
            requestIdleCallback(()=>setTimeout(()=>requestIdleCallback(()=>{
                        setPauseAllAnimations(false);
                        window.removeEventListener('load', handleLoad);
                    }), 1));
        };
        if (document.readyState === 'complete') {
            handleLoad();
        } else {
            window.addEventListener('load', handleLoad);
        }
        return ()=>window.removeEventListener('load', handleLoad);
    }, []);
    return pauseAllAnimations ? /*#__PURE__*/ _jsx("style", {
        children: `
          *, *::before, *::after {
            animation-play-state: paused !important;
          }
      `
    }) : null;
}
export default PauseAnimations;
